import React from 'react';
import { AMIAlert, AMICheckbox } from '../../../../ui-components/UiComponents';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { appDataSelector } from '../../../../features/appDataSlice';
import { bookingActions, bookingSelector } from '../../../../features/bookingSlice';
import { isRuleTrue } from '../../../../utilities/RulesEngineUtilities';
import { isBannerActive } from '../../../../utilities/ContentRetrieverUtilities';
import {
  getIncompleteIndexes,
  getPidAcknowledgement,
  isAcknowledgementRequired,
  isHardBlocked
} from '../../../../utilities/PidUtilities';

// Fixed fallback allowed by spec FR-008 when the acknowledgement content entry is unavailable.
const FALLBACK_LABEL = 'I accept the risk of booking with incomplete product identifiers';

const PidAcknowledgement = () => {

  const dispatch = useAppDispatch();
  const booking = useAppSelector(bookingSelector);
  const appData = useAppSelector(appDataSelector);

  const pidClass = booking.pidApplicable ?? 'NOT_APPLICABLE';
  const commodities = booking.customsDetails.commodities;
  const hardBlock = isRuleTrue(appData.customRules, 'pidHardBlock');
  const acknowledgement = getPidAcknowledgement(booking);
  const entry = appData.pidAdvisory?.entries?.acknowledgement;

  if (isHardBlocked(pidClass, commodities, hardBlock)) {
    return (
      <AMIAlert variant="error" style={{marginBottom: "24px"}}>
        Merchant and manufacturer product identifiers are required on every commodity for this shipment.
      </AMIAlert>
    )
  }

  if (!isAcknowledgementRequired(pidClass, commodities, hardBlock)) return null;

  const onChange = (event: any, checked: boolean) => {
    if (checked) {
      dispatch(bookingActions.setPidAcknowledgement({
        acknowledged: true,
        acknowledgedAt: new Date().toISOString(),
        incompleteAtAck: getIncompleteIndexes(commodities)
      }));
    } else {
      dispatch(bookingActions.clearPidAcknowledgement());
    }
  }

  return (
    <AMICheckbox
      className="pid-acknowledgement"
      text=""
      checked={acknowledgement.acknowledged}
      onChange={onChange}
    >
      {entry && isBannerActive(entry)
        ? <span dangerouslySetInnerHTML={{__html: entry.content}}></span>
        : <span>{FALLBACK_LABEL}</span>
      }
    </AMICheckbox>
  )
}

export default PidAcknowledgement;
